var externalLink = "<svg width=\"16\" height=\"16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g stroke=\"#7F91A5\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\">\n    <path d=\"M13.799 2.071L8.031 7.84M14.506 5.607V1.364h-4.243\" stroke-linejoin=\"round\"/>\n    <path d=\"M8.142 3.423H.556v12.015h11.767v-8.17\"/>\n  </g>\n</svg>";

export { externalLink as default };
